import { createSlice } from '@reduxjs/toolkit';
import {
    getDataReportOxygen,
    getDataReportTemperature,
    getDataReportSaturation,
    getDataReportSalinity,
    getDataReportChlorophyll,
    getDataReportTurbidity,
    getDataReportAll,
    getMeasurementList,    
    getInformationRegisterSMAList,    
    addInformationRegisterSMA
} from '../dataProviders/thunk';

export const initialOxygenState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    error: null,
};

export const initialTemperatureState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    error: null,
};

export const initialSaturationState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    error: null,
};

export const initialSalinityState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    error: null,
};

export const initialChlorophyllState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    error: null,
};

export const initialTurbidityState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    error: null,
};

export const initialAllState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    error: null,
};

export const initialMeasurementState = {
	itemMeasurementList: [],
	itemMeasurement: null,
	isMeasurementLoading: false,
	isMeasurementSuccess: false,

	dataMeasurement: null,
	measurementList: [],
	measurementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false
};



export const initialInformationRegisterSMAState = {
	itemInformationRegisterSMAList: [],
	itemInformationRegisterSMA: null,
	isInformationRegisterSMALoading: false,
	isInformationRegisterSMASuccess: false,

	dataInformationRegisterSMA: null,
	informationRegisterSMAList: [],
	informationRegisterSMAListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false
};

// Oxygen Slice
const DataProviderOxygenSlice = createSlice({
    name: 'DataProvidersOxygen',
    initialState: initialOxygenState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDataReportOxygen.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.error = null;
            })
            .addCase(getDataReportOxygen.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(getDataReportOxygen.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.error = action.error.message;
                state.data = null;
            });
    },
});

// Temperature Slice
const DataProviderTemperatureSlice = createSlice({
    name: 'DataProvidersTemperature',
    initialState: initialTemperatureState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDataReportTemperature.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.error = null;
            })
            .addCase(getDataReportTemperature.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(getDataReportTemperature.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.error = action.error.message;
                state.data = null;
            });
    },
});

// Saturation Slice
const DataProviderSaturationSlice = createSlice({
    name: 'DataProvidersSaturation',
    initialState: initialSaturationState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDataReportSaturation.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.error = null;
            })
            .addCase(getDataReportSaturation.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(getDataReportSaturation.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.error = action.error.message;
                state.data = null;
            });
    },
});

// Salinity Slice
const DataProviderSalinitySlice = createSlice({
    name: 'DataProvidersSalinity',
    initialState: initialSalinityState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDataReportSalinity.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.error = null;
            })
            .addCase(getDataReportSalinity.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(getDataReportSalinity.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.error = action.error.message;
                state.data = null;
            });
    },
});



// Chlorophyll Slice
const DataProviderChlorophyllSlice = createSlice({
    name: 'DataProvidersChlorophyll',
    initialState: initialChlorophyllState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDataReportChlorophyll.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.error = null;
            })
            .addCase(getDataReportChlorophyll.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(getDataReportChlorophyll.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.error = action.error.message;
                state.data = null;
            });
    },
});

// Turbidity Slice
const DataProviderTurbiditySlice = createSlice({
    name: 'DataProvidersTurbidity',
    initialState: initialTurbidityState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDataReportTurbidity.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.error = null;
            })
            .addCase(getDataReportTurbidity.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(getDataReportTurbidity.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.error = action.error.message;
                state.data = null;
            });
    },
});

// All Slice
const DataProviderAllSlice = createSlice({
    name: 'DataProvidersAll',
    initialState: initialAllState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDataReportAll.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.error = null;
            })
            .addCase(getDataReportAll.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(getDataReportAll.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.error = action.error.message;
                state.data = null;
            });
    },
});


// Measurement Slice
const DataProvidersMeasurementSlice = createSlice({
	name: 'DataProvidersMeasurements',
	initialState: initialMeasurementState,
	extraReducers: builder => {
		builder.addCase(getMeasurementList.pending, state => {
			state.isMeasurementSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getMeasurementList.fulfilled, (state, action) => {
			state.measurementList = action.payload.data;
			state.isLoadingList = false;
			state.isMeasurementSuccess = true;
		});
		builder.addCase(getMeasurementList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isMeasurementSuccess = true;
		});
	},
});


// InformationRegisterSMA Slice
const DataProvidersInformationRegisterSMASlice = createSlice({
	name: 'DataProvidersInformationRegisterSMA',
	initialState: initialInformationRegisterSMAState,
	extraReducers: builder => {
		builder.addCase(getInformationRegisterSMAList.pending, state => {
			state.isInformationRegisterSMASuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getInformationRegisterSMAList.fulfilled, (state, action) => {
			state.informationRegisterSMAList = action.payload.data;
			state.isLoadingList = false;
			state.isInformationRegisterSMASuccess = true;
		});
		builder.addCase(getInformationRegisterSMAList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isInformationRegisterSMASuccess = true;
		});

		builder.addCase(addInformationRegisterSMA.pending, state => {
			state.isInformationRegisterSMASuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(addInformationRegisterSMA.fulfilled, (state, action) => {
			state.informationRegisterSMAList = action.payload.data;
			state.isLoadingList = false;
			state.isInformationRegisterSMASuccess = true;
		});
		builder.addCase(addInformationRegisterSMA.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isInformationRegisterSMASuccess = true;
		});
        

 
	},
});

export const OxygenProviderReducer = DataProviderOxygenSlice.reducer;
export const TemperatureProviderReducer = DataProviderTemperatureSlice.reducer;
export const SaturationProviderReducer = DataProviderSaturationSlice.reducer;
export const SalinityProviderReducer = DataProviderSalinitySlice.reducer;
export const ChlorophyllProviderReducer = DataProviderChlorophyllSlice.reducer;
export const TurbidityProviderReducer = DataProviderTurbiditySlice.reducer;
export const AllProviderReducer = DataProviderAllSlice.reducer;
export const MeasurementReducer = DataProvidersMeasurementSlice.reducer;
export const InformationRegisterSMAReducer = DataProvidersInformationRegisterSMASlice.reducer;
